"use client";
import { Spinner } from "react-bootstrap";

const DatagridLoadingOverlay = () => {
  return <Spinner animation="border" variant="secondary" />;
};

export default DatagridLoadingOverlay;
